/* @flow */
import Session from './modules/session'
import Account from './modules/account'
import Devices from './modules/devices'
import Users from './modules/users'
import Info from './modules/info'
import Commands from './modules/commands'

export default {
  modules: {
    dhq_session: Session,
    dhq_account: Account,
    dhq_devices: Devices,
    dhq_users: Users,
    dhq_info: Info,
    dhq_commands: Commands,
  },
}



// WEBPACK FOOTER //
// ./src/devicehq/store/devicehq_modules.js